import { boolean, object, string } from 'yup'

const UberOfferSchema = object().shape({
  title: string().max(10, 'Title must be at most 10 characters').trim(),
  first_name: string()
    .required('First name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'First name can only contain letters and basic punctuation',
    )
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must be at most 50 characters')
    .trim(),
  last_name: string()
    .required('Last name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,50}$/,
      'Last name can only contain letters and basic punctuation',
    )
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must be at most 50 characters')
    .trim(),
  email: string()
    .required('Email is required')
    .matches(
      /^([a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*)@([a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,})$/,
      'Email must be a valid email address',
    )
    .max(100)
    .trim(),
  tel: string()
    .required('Phone is required')
    .matches(/^[+?\d ]{0,11}$/, 'Phone number must be a valid phone number')
    .max(11, 'Phone number must be at most 11 characters')
    .trim(),
  consent: boolean(),
  address_line1: string()
    .required('Address line 1 is required')
    .max(100, 'Address line 1 must be at most 100 characters')
    .trim(),
  address_line2: string()
    .max(100, 'Address line 2 must be at most 100 characters')
    .trim(),
  town: string()
    .required('Town/City is required')
    .max(50, 'Town must be at most 50 characters')
    .trim(),
  county: string().max(50, 'County must be at most 50 characters').trim(),
  postcode: string()
    .required('Postcode is required')
    .max(20, 'Postcode must be at most 20 characters')
    .trim(),
  message: string().max(200, 'Message must be at most 300 characters').trim(),
})

export default UberOfferSchema
